export const pointRequest = {
  loyaltyPointRequest: "Loyalty Point Request",
  pointRequest: "Point Request",
  search: "Search",
  from: "From",
  to: "To",
  username: "USERNAME",
  amount: "AMOUNT",
  requestedBy: "REQUESTED BY",
  createdDate: "CREATED DATE",
  approve: "Appove",
  reject: "Reject",
  close: "Close",
  approvedBy: "APPROVED BY",
  approvedAt: "APPROVED DATE",
};
